import { useI18n } from '~/common/context';
import { RichTextEditorField as BaseRichTextEditorField } from '@wyz/ui';

import * as React from 'react';

type RichTextEditorProps = React.ComponentProps<typeof BaseRichTextEditorField>;
function RichTextEditorField(props: Omit<RichTextEditorProps, 'translate'>) {
  const { t } = useI18n();

  return <BaseRichTextEditorField {...props} translate={t} />;
}

export default RichTextEditorField;
